<button
  *permissions="[Permissions.READ_MEMO]"
  class="sui-btn sui-btn-ghost sui-btn-sm sui-btn-icon"
  [suiDropdown]="managerApprovalMenu"
  suiDropdownAlign="end"
  (suiDropdownOpened)="onOpen()"
  suiTooltip="Manager Approval"
  suiTooltipPlacement="bottom"
>
  <i class="sui-icon sui-icon-seal-check"></i>
</button>

<ng-template #managerApprovalMenu>
  <div class="w-96 p-3 space-y-3">
    <div class="flex items-center gap-1.5">
      <i class="sui-icon sui-icon-seal-check text-muted"></i>
      <span class="text-sm font-medium text-surface-content">Manager Approval</span>
    </div>

    @if (isLoading()) {
      <div class="flex items-center justify-center py-10">
        <i class="sui-spinner text-muted"></i>
      </div>
    } @else if (loadFailed()) {
      <div class="space-y-3 py-2">
        <p class="text-sm text-error-500">Couldn't load the manager approval note.</p>
        <button class="sui-btn sui-btn-sm sui-btn-secondary" (click)="onOpen()">Try again</button>
      </div>
    } @else {
      <textarea
        class="sui-textarea sui-textarea-full max-h-72"
        rows="8"
        autocomplete="off"
        aria-label="Manager approval note"
        [value]="content()"
        [readOnly]="!canWrite()"
        [disabled]="isSaving()"
        (input)="onContentInput($any($event.target).value)"
      ></textarea>

      <div class="flex items-center justify-between gap-2">
        <span class="text-xs text-muted truncate">
          @if (updatedAt(); as updated) {
            Updated {{ updated | userDateTimeFormat }}
          }
        </span>
        @if (canWrite()) {
          <button
            class="sui-btn sui-btn-sm sui-btn-primary"
            [class.sui-btn-loading]="isSaving()"
            [disabled]="!isDirty() || isSaving()"
            (click)="onSave()"
          >
            Save
          </button>
        }
      </div>
    }
  </div>
</ng-template>
